export class ChangePasswordParameters {
  UserName: string;
  OldPassword: string;
  NewPassword: string;
  ConfirmPassword: string;
}

export class ResetPasswordParameters { 
  Username: string;
  PhoneNumber: string;
  FirstQuestion: string;
  FirstAnswer: string;
  SecondQuestion: string;
  SecondAnswer: string;
}

export class ChangePasswordResponse {
  RESPONSE_CODE: string;
  RESPONSE_DESC: string;
}

export class ResetPasswordResponse {
  RESPONSE_CODE: string;
  RESPONSE_DESC: string;
}